import swal from "sweetalert2";
import BreadCrumbs from "../../common/breadcrumbs";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import Modal from "../../common/Modal";
import AddUpdate from "./addUpdate";
import SingleStatusToggle from "../../common/singleStatusToggle";
import {
	useDeleteCategoryById,
	useGetAllCategories,
	useUpdateFoodCategories,
} from "../../../queryHooks/useCategories";
import ReactTooltip from "react-tooltip";
import Icon from "../../icons/index";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import CS from "../../../services/commonService";
import React, { useState, useEffect, useCallback } from "react";
import { useStore } from "../../../zustand/store";
import qs from "qs";
import { pageToLoadOnDelete } from "../../../helpers";

//	Pre-defined values
const columnKey = "categories";
//	Component starts
const Categories = () => {
	//	State values
	const setLoading = useStore((state) => state.setLoading);
	const [category, setCategory] = useState({});
	const [open, setOpen] = useState(false);
	const [tableData, setTableData] = useState();
	const [pageNow, setPageNow] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);

	//getCategories
	const [getCategoriesPayload, setCategoriesPayload] = useState({
		pagination: true,
		items_per_page: itemsPerPage,
		page: pageNow,
		sort: { created_at: "DESC" },
	});

	/******************************************************************************************
	@Purpose    :   To get the categories list
	*******************************************************************************************/

	const {
		data: dataGetCategories,
		isLoading,
		refetch: getCategories,
	} = useGetAllCategories(qs.stringify(getCategoriesPayload));

	useEffect(() => {
		if (dataGetCategories) {
			setLoading(false);
			if (dataGetCategories.status === "success") {
				let respData = dataGetCategories.data;
				respData.page = pageNow;
				respData.items_per_page = itemsPerPage;
				setTableData(respData);
			}
		}
	}, [dataGetCategories]);

	/******************
	 * update status
	 */

	const handleChangeStatus = (id, status) => {
		setLoading(true);
		const fileData = new FormData();
		fileData.append("is_featured", status);
		const obj = {
			fileData: fileData,
			id: id,
		};
		updateFoodCategories(obj);
	};

	const {
		mutateAsync: updateFoodCategories,
		error: errorUpdateFoodCategories,
		data: dataUpdateFoodCategories,
	} = useUpdateFoodCategories();

	useEffect(() => {
		if (dataUpdateFoodCategories) {
			setLoading(false);
			if (dataUpdateFoodCategories.status === "success") {
				getCategories();
				CS.showSuccessMessage(dataUpdateFoodCategories.message);
			} else if (dataUpdateFoodCategories.status === "fail") {
				CS.showErrorMessage(dataUpdateFoodCategories.message);
			}
		}
	}, [dataUpdateFoodCategories]);

	useEffect(() => {
		if (errorUpdateFoodCategories) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateFoodCategories.response?.data?.message);
		}
	}, [errorUpdateFoodCategories]);

	/******************************************************************************************
	@Purpose    :   To close the modal
	*******************************************************************************************/
	const closeModal = useCallback(
		(reload) => {
			setOpen(false);
			setCategory({});
			if (reload === true) getCategories();
		},
		[getCategories]
	);

	/***************************************************
	 * @DeleteCategories
	 */

	const {
		mutateAsync: deleteCategory,
		error: errordeleteCategory,
		data: datadeleteCategory,
	} = useDeleteCategoryById();

	useEffect(() => {
		if (datadeleteCategory) {
			setLoading(false);
			if (datadeleteCategory?.status === "success") {
				let _page = pageToLoadOnDelete(
					tableData?.total_items,
					1,
					pageNow,
					itemsPerPage
				);
				if (_page === pageNow) getCategories();
				setPageNow(_page);
				setCategoriesPayload({ ...getCategoriesPayload, page: _page });
				CS.showSuccessMessage(datadeleteCategory?.message);
			} else if (datadeleteCategory?.status === "fail") {
				CS.showErrorMessage(datadeleteCategory?.message);
			}
		}
	}, [datadeleteCategory]);

	useEffect(() => {
		if (errordeleteCategory) {
			setLoading(false);
			CS.showErrorMessage(errordeleteCategory?.response?.data?.message);
		}
	}, [errordeleteCategory]);

	/*************************************
	 *
	 * columns
	 **********************************/
	const columns = [
		{
			label: "Category Name",
			type: "string",
			sort: true,
			alias: "name",
			path: "name",
			content: (item) => (
				<div className="d-flex align-items-center">
					<div className="flex-auto">
						{CS.renderImageUrl(item?.image_url, "admin", true)}
					</div>
					<div className="d-flex flex-column flex-wrap">
						<span className="pl-2">
							{" "}
							<a
								href="#"
								onClick={() => {
									setOpen(true);
									setCategory(item);
								}}
							>
								{item?.name} {item?.emoji}
							</a>
						</span>
					</div>
				</div>
			),
		},
		{
			label: "Created On",
			type: "string",
			sort: true,
			alias: "created_at",
			path: "created_at",
			filterDate: true,
			content: (item) => getCurrentTimezoneDate(item?.created_at, true),
		},
		{
			label: "Status",
			type: "string",
			aliasFilter: "is_featured",
			filterOptions: [
				{ value: 1, label: "Active" },
				{ value: 0, label: "Inactive" },
			],
			content: (item) => (
				<SingleStatusToggle
					_id={item?.id}
					status={item?.is_featured == 1 ? true : false}
					onToggleChange={() =>
						handleChangeStatus([item?.id], !item?.is_featured)
					}
					htmlFor={item?.id}
				/>
			),
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="edit"
						data-tip
						data-for="edit"
						onClick={() => {
							setLoading(false);
							setOpen(true);
							setCategory(item);
						}}
					/>
					<ReactTooltip id="edit">Edit</ReactTooltip>
					<Icon
						type="delete"
						data-tip
						data-for="delete"
						onClick={() =>
							swal
								.fire({
									title: "Are you sure you want to delete?",

									icon: "warning",
									showCancelButton: true,
									confirmButtonColor: "#3085d6",
									cancelButtonColor: "#d33",
									confirmButtonText: "Yes, delete it!",
								})
								.then((result) => {
									if (result.isConfirmed) {
										setLoading(true);
										deleteCategory(item?.id);
									}
								})
						}
					/>
					<ReactTooltip id="delete" place="top" effect="solid">
						Delete
					</ReactTooltip>
				</>
			),
		},
	];

	return (
		<>
			<BreadCrumbs title="Master Management" data={[{ label: "Categories" }]} />
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												search={(value) => {
													setPageNow(1);
													setCategoriesPayload({
														...getCategoriesPayload,
														search: {
															name: !value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="right-buttons d-flex justify-content-end">
											<button
												onClick={() => setOpen(true)}
												id="addNewCategory"
												type="button"
												className="btn glow-primary btn-primary"
											>
												<i className="bx bx-user-plus d-lg-none" />
												<span className="d-none d-sm-none d-lg-inline-block">
													Add Category
												</span>
											</button>
											{/* <Download columnKey={columnKey} /> */}
										</div>
									</div>
								</div>
							</div>
							<Modal open={open} onCloseModal={closeModal}>
								<AddUpdate
									category={category}
									columnKey={columnKey}
									onCloseModal={closeModal}
									getCategories={getCategories}
								/>
							</Modal>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setCategoriesPayload({
										...getCategoriesPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setCategoriesPayload({ ...getCategoriesPayload, page });
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setCategoriesPayload({
										...getCategoriesPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(
											getCategoriesPayload.filter,
											obj
										);
										setPageNow(1);
										setCategoriesPayload({
											...getCategoriesPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setCategoriesPayload({
											...getCategoriesPayload,
											filter: {
												...getCategoriesPayload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setCategoriesPayload({
										...getCategoriesPayload,
										filter_date: dates && {
											...getCategoriesPayload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Categories;
